export const SET_LOADING = 'SET_LOADING'
export const UPDATE_MANAGERS = 'UPDATE_MANAGERS'
export const DELETE_MANAGER = 'DELETE_MANAGER'
